import { Component, OnDestroy } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { SplashComponent } from './shared/components/splash/splash.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NgIf, RouterOutlet, LoaderComponent, SplashComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnDestroy {
  showSplash = window.location.pathname === '/';
  private readonly splashTimer = this.showSplash
    ? window.setTimeout(() => (this.showSplash = false), 2800)
    : undefined;

  ngOnDestroy(): void {
    if (this.splashTimer !== undefined) window.clearTimeout(this.splashTimer);
  }
}
